import React, { useState, useEffect } from "react";
import { Outlet, Navigate } from "react-router";
import { Box, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useActivityTracker from "./custom-hooks/useActivityTracker";
// import webSocketHandler from "../handlers/WebsocketHandler";
import LogSocketHandler from "../handlers/ws/LogSocketHandler";

function ProtectedRoot() {
  const theme = useTheme();
  const [isLogin, setIsLogin] = useState(null);

  useActivityTracker();

  useEffect(() => {
    const storedLoginState = sessionStorage.getItem("loginState");
    const isLoggedIn = storedLoginState === "true";
    setIsLogin(isLoggedIn);

    if (isLoggedIn && !LogSocketHandler.isConnected) {
      LogSocketHandler.connect();
    }
  }, []);

  if (isLogin === null) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.primary,
          transition: "background-color 0.3s ease-in-out",
        }}
      >
        <CircularProgress sx={{ color: theme.palette.primary.main, mb: 2 }} />
      </Box>
    );
  }

  return isLogin ? <Outlet /> : <Navigate to="/login" />;
}

export default ProtectedRoot;
